import * as React from 'react';
import * as styles from './Pagination.css';
import { PaginationButton } from './PaginationButton';
import { usePagination } from '../../../../../hooks/usePagination';
import { IconBlankFilled16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Pagination(_ref) {
  let {
    onClick,
    currentPage,
    lastPage
  } = _ref;
  const {
    pages,
    isPrevButtonEnabled,
    isNextButtonEnabled
  } = usePagination({
    currentPage,
    lastPage
  });
  return /*#__PURE__*/_jsxs("nav", {
    className: styles['pagination'],
    children: [/*#__PURE__*/_jsx(PaginationButton, {
      page: currentPage - 1,
      title: "\u041D\u0430\u0437\u0430\u0434",
      onClick: onClick,
      disabled: !isPrevButtonEnabled,
      beforeIcon: /*#__PURE__*/_jsx(IconBlankFilled16, {
        color: isPrevButtonEnabled ? 'icon-primary-default' : 'icon-primary-disabled'
      })
    }), /*#__PURE__*/_jsx("ul", {
      className: styles['pages-list'],
      children: pages.map(page => /*#__PURE__*/_jsx("li", {
        className: styles['page'],
        children: /*#__PURE__*/_jsx(PaginationButton, {
          page: page.page,
          disabled: page.disabled,
          title: page.title,
          onClick: onClick
        })
      }, page.page))
    }), /*#__PURE__*/_jsx(PaginationButton, {
      page: currentPage + 1,
      title: "\u0414\u0430\u043B\u044C\u0448\u0435",
      onClick: onClick,
      disabled: !isNextButtonEnabled,
      beforeIcon: /*#__PURE__*/_jsx(IconBlankFilled16, {
        color: isNextButtonEnabled ? 'icon-primary-default' : 'icon-primary-disabled'
      })
    })]
  });
}